import { cn } from '@repo/utils';

interface HeroNumberProps {
  value: React.ReactNode;
  label?: string;
  size?: 'lg' | 'xl';
  className?: string;
}

export function HeroNumber({ value, label, size = 'xl', className }: HeroNumberProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <span className="text-xs font-medium text-text-secondary uppercase tracking-wide">
          {label}
        </span>
      )}
      <span
        className={cn(
          'font-newsreader font-semibold tnum leading-none',
          size === 'xl' ? 'text-5xl' : 'text-4xl',
          'text-text-primary',
        )}
      >
        {value}
      </span>
    </div>
  );
}
